import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import { KD_COUNTRY } from '../../constants';

function TypeSelector({
  selected,
  onChange,
  tiny,
  theme,
  typeOptions,
  isInputVisible,
}) {
  return (
    <select
      className={classNames(
        { 'c-select-tiny': tiny },
        { 'c-select-tiny--with-mainselector': isInputVisible },
        { [theme['c-select-tiny']]: tiny },
        { [theme['c-select-tiny--with-mainselector']]: isInputVisible },
      )}
      onChange={event => {
        onChange(event.target.value);
      }}
      value={selected}
    >
      {typeOptions.map(option => (
        <option value={option.value} key={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}

TypeSelector.propTypes = {
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  selected: PropTypes.string,
  onChange: PropTypes.func,
  tiny: PropTypes.bool,
};
TypeSelector.defaultProps = {
  selected: KD_COUNTRY,
  tiny: true,
};

export default TypeSelector;



// WEBPACK FOOTER //
// ./app/components/KdSelectGeography/TypeSelect.js